import { __generator, __values } from "tslib";
import { partial } from 'lodash-es';
import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import * as actionCreators from '../actionCreators';
import * as actionTypes from '../constants/actionTypes';
import { createProjectConfig } from '../createProjectConfig';
import { getProjectID } from '../selectors/project';
import * as api from '../services/api';
import isBrowserInFullScreenMode from '../utils/isBrowserInFullScreenMode';
export default function loadProject() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([fork(loadFullProject), fork(loadProjectPreview)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function loadFullProject() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actionTypes.LOAD_FULL_PROJECT, function (_a) {
                    var id = _a.id, token = _a.token;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!!id) return [3 /*break*/, 3];
                                if (!isBrowserInFullScreenMode()) return [3 /*break*/, 1];
                                /* eslint-disable no-param-reassign */
                                // eslint-disable-next-line prefer-destructuring
                                id = window.location.pathname.split('/')[1];
                                return [3 /*break*/, 3];
                            case 1: return [4 /*yield*/, select(getProjectID)];
                            case 2:
                                /* eslint-disable no-param-reassign */
                                id = _b.sent();
                                _b.label = 3;
                            case 3: 
                            // throw new Error('ID is not defined');
                            return [4 /*yield*/, put(actionCreators.loadFullProjectStarting(id))];
                            case 4:
                                // throw new Error('ID is not defined');
                                _b.sent();
                                return [5 /*yield**/, __values(fetchProject(id, partial(api.getProject, id, token), actionCreators.loadFullProjectDone, actionCreators.loadFullProjectFailed, token))];
                            case 5:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function loadProjectPreview() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actionTypes.LOAD_PROJECT_PREVIEW, function (_a) {
                    var id = _a.id, screenID = _a.screenID, token = _a.token;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, put(actionCreators.loadProjectPreviewStarting(id))];
                            case 1:
                                _b.sent();
                                return [5 /*yield**/, __values(fetchProject(id, partial(api.getProjectPreview, id, screenID, token), actionCreators.loadProjectPreviewDone, actionCreators.loadProjectPreviewFailed))];
                            case 2:
                                _b.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function fetchProject(id, apiFn, done, failed, token) {
    var project, projectConfig, err_1, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 9]);
                return [4 /*yield*/, call(apiFn)];
            case 1:
                project = _a.sent();
                projectConfig = createProjectConfig(project);
                return [4 /*yield*/, put(done(projectConfig, token))];
            case 2:
                _a.sent();
                return [3 /*break*/, 9];
            case 3:
                err_1 = _a.sent();
                if (!(err_1 instanceof window.Response)) return [3 /*break*/, 7];
                response = err_1;
                if (!(response.status === 404)) return [3 /*break*/, 5];
                // eslint-disable-next-line no-console
                console.error("Project with id '".concat(id, "' does not exist."));
                return [4 /*yield*/, put(actionCreators.notFound(id))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                if (!(response.status === 403)) return [3 /*break*/, 7];
                return [4 /*yield*/, put(actionCreators.passwordRequired(id))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [4 /*yield*/, put(failed(id, err_1))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
